module.exports = __webpack_public_path__ + "img/motherhood_return.7ecec71a.png";